import { filterUndefinedAndEmptyValues, gtmEvent } from '../../utils/gtmEvents';
import isSSR from '../../utils/isSSR';
const gtmDealerCardCtaClick = ({ model, linkUrl, componentType, dealerName }) => {
    const pathName = isSSR() ? '' : window.location.origin;
    const gtmPayload = {
        event: 'dealer_inventory_change_dealer',
        dealer_name: dealerName,
        cta_type: 'see inventory',
        cta_placement: 'dealer inventory',
        link_text: 'see inventory',
        link_url: `${pathName}${linkUrl}`,
        component_type: componentType,
        model,
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export default gtmDealerCardCtaClick;
